export default __webpack_public_path__ + "static/phaser-0bd75bb0eed2ef8fcee1c370f5fafc41.svg";